import React from 'react';

import fetch from './../fetch';
import utils from './../../utils';
import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    data: [],
    refresh: function() {

    }
}

const headers = utils.columns([

    {type: 'selection'},
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'subName', 
        width: 200, 
        label: '诊改依据'
    },
    // {
    //     key:'assignOrgNameList', 
    //     width: 150, 
    //     label: '分配部门',
    //     render: (data) => {
    //         if(data && data.length > 0) {
    //             return <span> {data.join('、')}</span>
    //         }
    //         return "";
    //     }
    // },
    {
        key:'assignOrgName', 
        width: 150, 
        label: '分配部门',
    },
    {
        key:'isUploadAttachment', 
        width: 150, 
        label: '是否上传附件',
        render: (isUploadAttachment) => {
            if(isUploadAttachment == true) {
                return '是';
            } else if(isUploadAttachment == false) {
                return '否';
            } 
        } 
    },
    {
        key:'subDetailList', 
        label: '配置信息',
        width: 200, 
        render: (data) => {
            
            return data.map((d, index) => (
                <li>
                    <li>列标题{index +1}：{d.label} ~ 类型：{d.type=='Text'?'文本':d.type=='Standard'?'单选(评分标准)':d.type=='Time'?'时间':d.type=='Number'?'数字':d.type=='LinkageChoose'?'单选(联动)':d.type=='Choose'?'单选':d.type=='LinkageStandard'?'单选(联动+评分配置)':''};</li>
                    {/* {
                        d.type === 'options' ? (
                            d.moreOption.map((option,optionIndex) => (
                                option.optionType === 0 && option.columnId != ''? 
                                (
                                    <ul style={{listStyleType: 'none'}}>
                                        <li>选项名称{optionIndex +1}：{option.optionName}</li>
                                        {
                                            <ul style={{listStyleType: 'none'}}>
                                            {
                                                option.optionDetail.map((detail,detailIndex) => (                                 
                                                    <li>排名名称{detailIndex +1}：{detail.label} ~ 分数：{detail.valueNormal}</li>
                                                ))
                                            }
                                            </ul>
                                        }
                                    </ul>
                                ):(option.optionType === 1 && option.columnId != ''?
                                    ( 
                                        <ul style={{listStyleType: 'none'}}>
                                            <li>选项名称{optionIndex +1}：{option.optionName} ~ 分数：{option.optionScore}</li>    
                                        </ul>
                                    )
                                    :
                                    ""
                                )
                            ))
                        ):""
                    } */}
                </li>
            ))
        }
    },
    // {
    //     key:'id', 
    //     label: '预览效果', 
    //     width: 240, 
    //     render: (data) => {
    //         
    //         console.log(data)
    //         return(<Button 
    //             onClick={() => {
    //                 
    //                 if(data && data != undefined) {
    //                     this.props.insertOrUpdateTab({
    //                         url: '/jszg/subitem/view/' + data,
    //                         id: Date.now() + Math.random(),
    //                         name: "预览页面",
    //                         label: "预览页面"
    //                     });
    //                 } else {
    //                     Modal.warn({
    //                         title: '请选择数据',
    //                         content: '请先选择一条数据',
    //                         okText: '确认'
    //                     })
    //                 }
    //             }}
    //         >
    //             <Icon type="file"></Icon>查看预览
    //         </Button>)
    //     }
    // }
]);

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('jszg/subitem/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        console.log('error');
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('jszg/subitem/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => {
        const list = (Object.assign({
            result: (data.dataList || []).map(item => {
                return Object.assign({}, item, {
                    height: (item.subDetailList || []).length * 30
                })
            }),
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
                height: (d.subDetailList || []).length * 30
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        }));

        return list;
    });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('jszg/subitem/insert', data);
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('jszg/subitem/update/' + id, data);
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('jszg/subitem/remove/', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getUserSelectData = () => {
    const id = DataGrid.selections[0]
    return DataGrid.data.find(d => d.subId === id)
}

export default {
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    batchUpdate,
    getSelection,
    redirect,
    getUserSelectData
}